<template>
  <div>
      <page-title>{{title}}</page-title>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <keep-alive>
      <shipping-requests
        :shipping-requests="getBerthedShipments"
        :isBackendPaginated="true"
        :currentPage="currentPage"
        :total="total"
        :onPageChange="onPageChange"
        activePort
      ></shipping-requests>
    </keep-alive>
  </div>
</template>

<script>
import ShippingRequests from "@/modules/commonModule/components/shippingRequestsList/Main";
import SYSTEM_FLAGS from "@/modules/commonModule/helpers/getSystemFlags";
import GetPortsBerthedShipments from "@/modules/nimasaAgentModule/api/graphql/queries/GetPortsBerthedVessels";
import { NIMASA_AGENT_MUTATION_TYPES } from "@/store/mutation-types";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("nimasaAgent");

export default {
  name: "port-report-details",
  components: { ShippingRequests },
  props: { id: Number, title: String },
  data() {
    return {
      isLoading: true,
      currentPage: 1,
      total: 0,
    };
  },
  computed: {
    ...mapGetters({
      getBerthedShipments: "getPortsBerthedShipments",
    })
  },
  mounted() {
      this.loadBerthedShippingRequestsFromAPI()
  },

  methods: {
      ...mapMutations({
      saveBerthedShippingRequests:
        NIMASA_AGENT_MUTATION_TYPES.SAVE_PORTS_BERTHED_APPLICATIONS,
    }),
      loadBerthedShippingRequestsFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetPortsBerthedShipments,
          variables: {
            port_of_discharge_id: this.$route.params.id,
            port_status: SYSTEM_FLAGS.PORT_STATUS.DOCKED,
            page
          }
        })
        .then(response => {
          const shippingRequests = response.data.getPortsShippingRequests.data;
          this.saveBerthedShippingRequests(shippingRequests);
          const {
            total,
            currentPage
          } = response.data.getPortsShippingRequests.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Shipping requests loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load shipping requests",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loadDockedShippingRequestsFromAPI(this.currentPage);
    }
  }
  ,
};
</script>
